import { Component } from 'react'
import { AlertTriangle } from 'lucide-react'
import type { ErrorInfo, ReactNode } from 'react'
import { Button } from '@/components/ui/button'
import { m } from '@/lib/paraglide/messages'

interface Props {
    children: ReactNode
}

interface State {
    hasError: boolean
}

/** Global error boundary — catches unhandled React errors and shows fallback UI. */
export class ErrorBoundary extends Component<Props, State> {
    state: State = { hasError: false }

    static getDerivedStateFromError(): State {
        return { hasError: true }
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error('[ErrorBoundary]', error, info.componentStack)
    }

    render() {
        if (!this.state.hasError) return this.props.children

        return (
            <div className="h-screen flex flex-col items-center justify-center gap-4 p-8 text-center">
                <AlertTriangle className="size-12 text-destructive" />
                <h1 className="text-xl font-semibold">
                    {m.error_page_title()}
                </h1>
                <p className="text-muted-foreground">
                    {m.error_page_load_failed()}
                </p>
                <Button
                    onClick={() => {
                        this.setState({ hasError: false })
                        window.location.reload()
                    }}
                >
                    {m.error_page_retry()}
                </Button>
            </div>
        )
    }
}
